import { MpTypography } from './Typography'
export default MpTypography

export { MpTypography, MpTypographyProps } from './Typography'
